__turbopack_context__.v({
  "enhancedAvatarWrapper": "OrganizerInfo-module-scss-module__b0Tgea__enhancedAvatarWrapper",
  "enhancedByTag": "OrganizerInfo-module-scss-module__b0Tgea__enhancedByTag",
  "enhancedOrganizerInfoContent": "OrganizerInfo-module-scss-module__b0Tgea__enhancedOrganizerInfoContent",
  "enhancedOrganizerName": "OrganizerInfo-module-scss-module__b0Tgea__enhancedOrganizerName",
  "followButtonWrapper": "OrganizerInfo-module-scss-module__b0Tgea__followButtonWrapper",
  "metadataItem": "OrganizerInfo-module-scss-module__b0Tgea__metadataItem",
  "metadataRow": "OrganizerInfo-module-scss-module__b0Tgea__metadataRow",
  "organizerNameRow": "OrganizerInfo-module-scss-module__b0Tgea__organizerNameRow",
  "organizerTextContent": "OrganizerInfo-module-scss-module__b0Tgea__organizerTextContent",
  "wrapper": "OrganizerInfo-module-scss-module__b0Tgea__wrapper",
});
